import { appsContextFactory } from "./AppsContext";

export const WIDGET_LABELS = {
    "rse-promotions": "Promotions",
    "rse-initial-slides": "Slides initiales",
    "rse-news": "Actualités",
    "rse-docs": "Documentations",
    "rse-forms": "Formulaires",
    "rse-catalog": "Catalogue",
    "rse-social": "Social",
    "rse-pack": "Pack App rse²",
    "rse-tools": "Outils Catalogue & Site",
} as const;

export const RSE_WIDGETS = [
    "rse-promotions",
    "rse-news",
    "rse-docs",
    "rse-forms",
    "rse-catalog",
    "rse-tools",
    "rse-social",
    "rse-pack",
] as const;

export const { AppsProvider, useAppsContext } = appsContextFactory("rse-");
